type BuildLocationSlugParam = { city: string; stateCode: string; countryCode: string };
export function buildLocationSlug({ city, stateCode, countryCode }: BuildLocationSlugParam): string {
	return `${city}--${stateCode}--${countryCode}`.toLowerCase().replace(/\s+/g, '');
}
